export enum socketChatEnum {
  NEW_MESSAGE = "new-message",
}
